import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { concat, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { FileData } from '../../../core/model/massive-load-result';
import { ObservacionServicio } from '../../../core/model/observacion-servicio';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FileManagerService } from '../../../core/services/files/file-manager.service';
import { ObservacionesSolicitudService } from '../../../core/services/observaciones-solicitud.service';
import { FileType } from '../../../core/model/file';
import { SolicitudServicioService } from '../../../core/services/solicitud-servicio.service';


@Component({
  selector: 'app-commentscomponent',
  templateUrl: './commentscomponent.component.html',
  styleUrls: ['./commentscomponent.component.css']
})
export class CommentscomponentComponent implements OnChanges, OnInit, OnDestroy {

  @ViewChild('fileInput') fileInput;

  @Input() idSolicitud;
  @Input() nombreCliente;
  @Input() reload: boolean;
  @Input() sonComentariosAprobacion = false;
  @Input() buttonAddCommentText: string;
  @Input() todoFinalizado = false;
  @Input() hasApprovedFlow = false;
  modalRef: BsModalRef;
  internalcomment = false;
  clientname: string;

  statusCode: number;
  requestProcessing = false;
  noData = false;
  mensajeToShow: string;

  allComments: ObservacionServicio[];
  htmlContent: string;
  private subscription;
  private subscription_change;
  private subscription_get;

  isDocoutUser: boolean;
  isUserGestion = false;

  saveObservation = false;
  loadingObservations = false;

  commentForm = new FormGroup({
    txteditor: new FormControl({ value: '' }, Validators.required),
  });
  private files: FileData[] = [];

  private observationIdAdded: number;
  fileSizeError = false;

  constructor(private modalService: BsModalService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private authService: AuthenticationService,
    private observacionesSolicitudService: ObservacionesSolicitudService,
    private fileManagerService: FileManagerService,
    private solicitudService: SolicitudServicioService
  ) { }


  // region "Initialize"
  ngOnInit() {
    this.SetEnviroment();
    // this.InitLanguage();
    this.getAllObservaciones();
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['vistadetalle'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['vistadetalle'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }

  TranslateText(values: any) {

  }


  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.getClienteName$().subscribe(data => {
      this.clientname = data;
    });

    if (!this.isDocoutUser) {
      this.solicitudService.isGestionable(this.idSolicitud)
        .subscribe(
          (p) => this.isUserGestion = p
        );
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    const name: SimpleChange = changes.name;
    if (changes.reload) {
      const recarga = changes.reload.firstChange;
      if (!recarga) {
        this.getAllObservaciones();
      }
    }
  }
  // endregion

  getAllObservaciones() {
    this.preProcessProfile('Recuperando observaciones de la solicitud');
    this.loadingObservations = true;

    const methodCall = !this.sonComentariosAprobacion
      ? this.observacionesSolicitudService.getAllObservaciones(this.idSolicitud)
      : this.observacionesSolicitudService.getAllObservacionesAprobacion(this.idSolicitud);

    this.subscription_get = methodCall
      .subscribe(comments => {
        this.commentsManage(comments);
      },
        errorCode => {
          this.commentsErrorManage();
        });
  }

  private commentsManage(comments) {
    this.noData = false;
    this.allComments = new Array();
    this.allComments = comments;
    if (this.allComments.length <= 0) {
      this.noData = true;
    }
    this.createFilesShowed(this.allComments);
    this.requestProcessing = false;
    this.loadingObservations = false;
  }

  private createFilesShowed(allComments: ObservacionServicio[]): any {
    this.allComments.forEach(comment => {
      if (comment.Ficheros && comment.Ficheros.length > 0) {
        comment.filesShowed = comment.Ficheros.map(fichero => {
          return { guid: fichero.GUID, name: fichero.nombreFichero, date: fichero.fecha };
        });
      }
    });
  }

  private commentsErrorManage() {
    this.statusCode = 500;
    this.subscription = this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.warning(values['mensajes']['nodata'],
          values['mensajes']['nodatatitle']);
      });
    this.loadingObservations = false;
  }


  preProcessProfile(mensaje: string) {
    this.mensajeToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }






  ngOnDestroy() {

    if (!this.subscription == null) { this.subscription.unsubscribe(); }
    if (!this.subscription_change == null) { this.subscription_change.unsubscribe(); }
    if (!this.subscription_get == null) { this.subscription_get.unsubscribe(); }
    this.observacionesSolicitudService = null;
    this.authService = null;
    this.modalService = null;
    this.toastr = null;
  }

  // region "Modal comments"

  openModal(template: TemplateRef<any>, internal: boolean) {
    this.internalcomment = internal;
    this.modalRef = this.modalService.show(template);
  }

  closeModal() {
    this.saveObservation = false;
    this.files = [];
    this.modalRef.hide();
  }

  onCommentsSubmit() {
    // Validación previa del tamaño de los ficheros adjuntos
    if (this.files.find((fileData: FileData) => fileData.file.size > environment.MAX_FILESIZE)) {
      this.fileSizeError = true;
      return false;
    }

    this.fileSizeError = false;
    const calls: Map<number, Observable<any>> = new Map();
    calls.set(0,
      this.observacionesSolicitudService.addObservaciones(
        this.idSolicitud,
        this.htmlContent,
        this.internalcomment,
        null,
        this.sonComentariosAprobacion)
        .pipe(catchError((response: Response) => {
          return of(-1);
        })
    ));

    this.files.forEach((fileData: FileData) => {
      const observableNumber = calls.size;
      calls.set(observableNumber, this.fileManagerService.uploadFileToRepository(fileData.file, true, FileType.CARGA_MASIVA)
        .pipe(catchError((response: Response) => {
          return of(fileData);
        })));
    });

    this.sendSynchronousCalls(calls);
  }

  private sendSynchronousCalls(calls: Map<number, Observable<any>>): any {
    this.saveObservation = true;

    const output = this.concatObservables(calls);

    let indiceEjecucion = 0;
    let associateFilesObservables: Map<number, Observable<any>> = new Map();
    output.subscribe(resultSecuencial => {
      if (this.isAddObservationCallback(indiceEjecucion)) {
        this.manageObservationResponse(resultSecuencial);
      } else {
        associateFilesObservables = this.manageFilesInExecution(resultSecuencial, associateFilesObservables);
      }
      if (indiceEjecucion === calls.size - 1) {
        if (associateFilesObservables.size > 0) {
          this.associateFilesToObservation(associateFilesObservables);
        } else {
          this.closeModal();
          this.getAllObservaciones();
        }
      }
      indiceEjecucion++;
    });
  }

  private associateFilesToObservation(associateFilesObservables: Map<number, Observable<any>>): any {
    const output = this.concatObservables(associateFilesObservables);
    let indiceEjecucion = 0;
    output.subscribe(resultSecuencial => {
      if (resultSecuencial.error) {
        this.toastr.error(this.translateService.instant('mensajes.errorAssociatingFile') + resultSecuencial.GUID,
          this.translateService.instant('mensajes.errorServidor'));
      } else if (indiceEjecucion === associateFilesObservables.size - 1) {
        this.closeModal();
        this.getAllObservaciones();
      }
      indiceEjecucion++;
    });
  }

  private manageFilesInExecution(resultSecuencial: any, associateFilesObservables: Map<number, Observable<any>>): Map<number, Observable<any>> {
    if (!this.hasUploadFileError(resultSecuencial)) {
      associateFilesObservables.set(associateFilesObservables.size, this.fileManagerService.associateFileToComment(
        this.observationIdAdded, resultSecuencial
      ).pipe(catchError((response: Response) => {
        return of({ error: true, GUID: resultSecuencial });
      })));
    } else {
      this.toastr.error(this.translateService.instant('mensajes.errorUploadingFile') + resultSecuencial.filename,
        this.translateService.instant('mensajes.errorServidor'));
    }

    return associateFilesObservables;
  }

  private hasUploadFileError(result: any): any {
    return result.constructor.name == 'FileData';
  }

  private manageObservationResponse(resultSecuencial: any): any {
    if (this.hasError(resultSecuencial)) {
      this.toastr.error(this.translateService.instant('mensajes.errorContentObservationFile'),
        this.translateService.instant('mensajes.errorServidor'));
    } else {
      this.statusCode = resultSecuencial;
      this.observationIdAdded = resultSecuencial;
      this.htmlContent = undefined;
      this.noData = false;
    }
  }

  private hasError(resultSecuencial: any): any {
    return resultSecuencial == -1;
  }

  private isAddObservationCallback(indiceEjecucion: number): any {
    return indiceEjecucion == 0;
  }

  private concatObservables(observables: Map<number, Observable<any>>): Observable<any> {
    let output: Observable<any> = observables.get(0);
    for (let x = 1; x < observables.size; x++) {
      output = concat(output, observables.get(x));
    }
    return output;
  }


  muestraError(errorCode: HttpErrorResponse, mensaje: string) {
    this.statusCode = errorCode.status;
    // si hay errores extendidos por ADMIn se muestra  uno u otro

    if (mensaje.length <= 0 || !mensaje) {
      if (errorCode.error) {
        mensaje = errorCode.error.Message;
      } else {
        mensaje = errorCode.message;
      }
    }
    this.toastr.error('Se ha encontrado un error: ' + mensaje, this.translateService.instant('mensajes.errorServidor'));
  }

  getButtonAddCommentText() {
    if (this.buttonAddCommentText) {
      return this.buttonAddCommentText;
    }

    return this.translateService.instant('vistadetalle.cliente');
  }

  addFile(event) {
    const file = event.target.files[0];
    this.files.push(this.createFileData(file));
    this.files = [...this.files];
  }

  private createFileData(file: File, guid?: string): FileData {
    const fileData: FileData = new FileData();
    fileData.filename = file.name;
    fileData.extension = this.getExtension(file.name);
    fileData.size = this.calculateSizeFile(file.size);
    fileData.file = file;
    fileData.guid = guid;

    return fileData;
  }

  private getExtension(filename: string): string {
    const splitPoint = filename.split('.');
    return splitPoint[splitPoint.length - 1];
  }

  private calculateSizeFile(size: number): string {
    const sizeInKb = Math.ceil(size / 1000);
    if (sizeInKb < 1000) {
      return sizeInKb + ' Kb';
    }

    return Math.ceil(sizeInKb / 1000) + ' Mb';
  }

  removeFile(file: FileData) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
      this.files = [...this.files];
    }
  }

}
